import React, { useContext, useState, useEffect, useRef } from "react";
import {
  Container,
  Row,
  Col,
  Figure,
  FigureCaption,
  Image,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import axios from "axios";
import Header from "./header";
import Footer from "./footer";
import { UserContext } from "../../use_context";
import Lottie from "lottie-react";
import LoadingLottieAnimation from "../../js/Animation - 1715944216233.json";
import { useNavigate } from "react-router-dom";

const API_BASE_URL = process.env.REACT_APP_SEARCH_API;

function WorkListing() {
  const [selCatId, setSelCatId] = useState(null);
  const {
    isLoading,
    workData,
    workCategoryData,
    images,
    setImages,
    setIsLoading,
    setSelectedCategoryId,
    setWorkCategoryData,
    setWorkData,
  } = useContext(UserContext);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleCategorySelect = (categoryId) => {
    setSelCatId(categoryId);
    navigate(`/worksdetails/${categoryId}`);
  };

  const isDataFetched = useRef(false);
  // const isMounted = useRef(true);

  useEffect(() => {
    if (!isDataFetched.current) {
      if (!workCategoryData.length || !workData.length || !images.length) {
        fetchData();
      } else {
        isDataFetched.current = true;
      }
    }

    // return () => {
    //   isMounted.current = false;
    // };
  }, []);

  const fetchData = async () => {
    try {
      setIsLoading(true);

      const workCategoryResponse = await axios.get(
        `${API_BASE_URL}/work-category/`
      );
      setWorkCategoryData(workCategoryResponse.data);

      const workResponse = await axios.get(`${API_BASE_URL}/work/`);
      setWorkData(workResponse.data);

      const works = workResponse.data;
      const workImages = {};

      works.forEach((work) => {
        if (work.featured_media) {
          const mediaId = work.featured_media;
          if (!workImages[mediaId]) {
            workImages[mediaId] = [];
          }
          work["work-category"].forEach((categoryId) => {
            workImages[mediaId].push(categoryId);
          });
        }
      });

      const imagesPromises = Object.keys(workImages).map(async (mediaId) => {
        try {
          const mediaResponse = await axios.get(
            `${API_BASE_URL}/media/${mediaId}`
          );
          return {
            url: mediaResponse.data.guid.rendered,
            categories: workImages[mediaId],
          };
        } catch (mediaError) {
          console.error(
            `Error fetching media for media ID ${mediaId}:`,
            mediaError
          );
          return null;
        }
      });

      const resolvedImages = await Promise.all(imagesPromises);
      const validImages = resolvedImages.filter((image) => image !== null);
      setImages(validImages);
      isDataFetched.current = true;
    } catch (error) {
      console.error("Error fetching data", error);
      setError(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <main>
      <div>
        <Header onTagClick={handleCategorySelect} />
      </div>
      <section className="wide-container ">
        <Container>
          {isLoading && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                height: "100vh",
              }}
            >
              <div style={{ width: "300px", height: "300px" }}>
                <Lottie animationData={LoadingLottieAnimation} loop={true} />
              </div>
            </div>
          )}

          {error && <p>Error: {error.message}</p>}
          <Row className="work-listing gx-5">
            {workCategoryData.map(
              (category, index) =>
                (selCatId === null || selCatId === category.id) && (
                  <Col
                    className="worklisting-image"
                    key={index}
                    xs={12}
                    md={6}
                    lg={4}
                    onClick={() => handleCategorySelect(category.id)}
                  >
                    <Link to={"/worksdetails"}>
                      <div className="work-listing-item mix featured card media-card workplaces">
                        {images
                          .filter((imageData) =>
                            imageData.categories.includes(category.id)
                          )
                          .map((imageData, imageIndex) => (
                            <Figure key={imageIndex}>
                              <Image
                                src={imageData.url}
                                alt={`Work category ${index}`}
                                className="img2"
                              />
                            </Figure>
                          ))}
                      </div>

                      {/* Move FigureCaption outside the card */}
                      <FigureCaption
                        className="figure-caption"
                        style={{ textAlign: "end", paddingRight: "15px" }}
                      >
                        {workData
                          .filter((workItem) =>
                            workItem["work-category"].includes(category.id)
                          )
                          .map((workItem) => (
                            <React.Fragment key={workItem.id}>
                              <span
                                className="title"
                                style={{ fontWeight: 700 }}
                              >
                                {workItem.title.rendered}
                              </span>
                              <br></br>
                              <span className="location">
                                {workItem.acf.location}
                              </span>
                            </React.Fragment>
                          ))}
                      </FigureCaption>
                    </Link>
                  </Col>
                )
            )}
          </Row>
        </Container>
      </section>
      <Footer />
    </main>
  );
}

export default WorkListing;
